"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledApplicationListItem = exports.StyledUserProfileChangingEnvironment = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../../general");
const hoverActiveStyles = (0, styled_components_1.css) `
  background-color: ${theme_1.grayScale[100]};

  & p {
    color: ${theme_1.primary.light};
  }
  svg {
    background: ${theme_1.gradients.secondary.iconHover};
    circle {
      stroke: ${theme_1.primary.light};
    }
    path {
      fill: ${theme_1.primary.light};
    }
    rect ~ path {
      stroke: ${theme_1.primary.light};
      fill: none;
    }
  }
`;
const defaultStyles = (0, styled_components_1.css) `
  background-color: transparent;

  & p {
    color: ${theme_1.grayScale[600]};
  }

  svg {
    border-radius: 100%;
    circle {
      stroke: ${theme_1.grayScale[600]};
    }
    path {
      fill: ${theme_1.grayScale[600]};
    }
    rect ~ path {
      stroke: ${theme_1.grayScale[600]};
      fill: none;
    }
  }
  &.navigation-item svg {
    border-radius: 0;
  }
`;
exports.StyledUserProfileChangingEnvironment = (0, styled_components_1.default)(general_1.Flexbox) `
  border-top: 1px solid ${theme_1.grayScale[200]};
  margin-top: ${theme_1.spacings.s8};
  padding: ${theme_1.spacings.s8} 0 0;

  > div {
    height: ${theme_1.spacings.s10};
    padding: 0 0 0 ${theme_1.spacings.s4};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: ${theme_1.spacings.s3};
  }
`;
exports.StyledApplicationListItem = (0, styled_components_1.default)(general_1.Paper) `
  ${({ current, disabled }) => (0, styled_components_1.css) `
    transition: all 0.3s ease-in-out;
    align-items: center;
    flex-direction: row;
    padding: ${theme_1.spacings.s4};
    ${defaultStyles}
    &:hover {
      ${hoverActiveStyles}
    }
    ${current && hoverActiveStyles}
    ${disabled &&
    (0, styled_components_1.css) `
      cursor: not-allowed;
      &:hover {
        ${defaultStyles}
      }
    `}
  `}
`;
//# sourceMappingURL=styles.js.map